// TopBar.jsx
import React from 'react';
import { useState, useRef, useEffect } from 'react';

import brand_logo from "../img/brand_logo_black.png"
import profile_picture from "../img/profile_picture.png"
import { Link } from 'react-router-dom';

const TopBar = () => {

  //TODO eeeeh
  const user_name = localStorage.getItem("first_name")+" "+localStorage.getItem("last_name");
  const user_role = localStorage.getItem("role");

  const user={ name: user_name, role: user_role }
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  const path_admin = "/admin";
  const path_alias = "/alias";
  const path_teamalias = "/teamalias";
  const path_logos = "/logos";
  const path_logout = "/login";
  const path_colorconfig = "/colorconfig";
  const path_roleconfig = "/roleconfig";

  const logout = () => {
    localStorage.removeItem("role");
    localStorage.removeItem("first_name");
    localStorage.removeItem("last_name");
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    window.location.href=path_logout;
  }

  // Close the menu when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="top-bar">
      <div className="content">
        <div className="logo">
          <img src={brand_logo} alt="logo" />
        </div>

        {/* Ref goes here */}
        <div ref={menuRef} className="relative">
          <div className="profile-contents" onClick={() => setOpen(true)}>
            <div className="profile-icon-outer">
              <img className="profile-icon" src={profile_picture} alt="Profile" />
            </div>
            <div className="profile-data">
              <div className="profile-data-name">{user.name}</div>
              <div className="profile-data-role">{user.role}</div>
            </div>
          </div>

          {open && (
            <div className="relative inline-block text-left">
              <div className="dropdown">
                <Link to={path_admin} onClick={() => setOpen(false)} >
                  <span className="dropdown-item" style={{display: user_role==='Admin' ? 'block':'none'}}>Pannello Admin</span>
                </Link>
                <Link to={path_alias} onClick={() => setOpen(false)} >
                  <span className="dropdown-item">Gestione Alias Giocatori</span>
                </Link>
                <Link to={path_teamalias} onClick={() => setOpen(false)} >
                  <span className="dropdown-item">Gestione Alias Squadre</span>
                </Link>
                <Link to={path_logos} onClick={() => setOpen(false)} >
                  <span className="dropdown-item">Gestione Loghi e Simboli</span>
                </Link>
                <Link to={path_colorconfig} onClick={() => setOpen(false)} >
                  <span className="dropdown-item">Configurazione Colori</span>
                </Link>
                <Link to={path_roleconfig} onClick={() => setOpen(false)} >
                  <span className="dropdown-item">Configurazione Ruoli</span>
                </Link>

                <span className="dropdown-item" onClick={logout}>Logout</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>

  );
};

export default TopBar;
